import gsap from 'gsap'
import React, { useLayoutEffect, useRef } from 'react'

const Nophotocouple = ({details}) => {

  
    const sectionRef = useRef(null)
    const backgroundRef = useRef(null)
    const cardRef = useRef(null)


   const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t3-single-couple-container" data-aos="fade-up">

        <div className="t3-couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t3-couple-name">
          {fullname}
        </h1>

        <div className="t3-couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

  const groomCard = () =>
    renderPersonCard({
      fullname: details?.groomFullName || "Groom Full Name",
      parentprefix: details?.groomParentsPrefix,
      parentsName: details?.groomParents,
      grandParentsPrefix: details?.groomGrandParentsPrefix,
      grandParentsName: details?.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: details?.brideFullName || "Bride Full Name",
      parentprefix: details?.brideParentsPrefix,
      parentsName: details?.brideParents,
      grandParentsPrefix: details?.brideGrandParentsPrefix,
      grandParentsName: details?.brideGrandParents,
    });

       useLayoutEffect(() => {

    const ctx = gsap.context(() => {

      if (!sectionRef.current) return

      const background = backgroundRef.current
      const card = cardRef.current

      if (!background && !card) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
          once: true,
        }
      })

      if (background) {
        tl.fromTo(
          background,
          {
            autoAlpha: 0
          },
          {
            autoAlpha: 1,
            duration: 1.1,
            ease: "power2.out"
          }
        )
      }

      if (card) {
        tl.fromTo(
          card,
          {
            autoAlpha: 0,
            scale: 0.985
          },
          {
            autoAlpha: 1,
            scale: 1,
            duration: 1,
            ease: "power2.out"
          },
          "-=0.65"
        )
      }

    }, sectionRef)

    return () => ctx.revert()

  }, [])



  return (
    <section className="couple-section no-photo-couple theme3" ref={sectionRef}>
      <div className="theme-3-couple" ref={backgroundRef}>
          <div className="theme-3-couple-card" ref={cardRef}>
              <div className="t3-couple-inner-content">
                    <h1 className='t3-couple-heading' data-aos="fade-up">{details?.sectionHeading}</h1>
               <div className="t3-couple-wrapper">
                   {details?.displayOrder === "groomFirst" ? (
                    <>
                      {groomCard()}
                          <span className="t3-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {brideCard()}
                    </>
                   ) : ( <>
                       {brideCard()}
                         <span className="t3-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {groomCard()}
                   </>) } 
               </div>
              </div>           
          </div>
      </div>
    </section>
  )
}

export default Nophotocouple